import _ from "lodash";
import Box from "../components/box";
import Btn from "../components/btn";
import h from "../core/createElement";
import Modal from "../core/modalEngine";
import { switchable_element } from "../utils";
import GroupCard from "../components/group_card";
import GroupModal from "./group_modal";
import EmptyMsgBox from "../components/empty_msg";
import GenericConfirmModal from "./generic_confirm";
import group_service from "../service/group_service";
import popupAlerts from "../core/popupAlerts";

function ListGroups({ hide, onInit, shared = {} }) {
    const
        ept_msg = <EmptyMsgBox text="Nenhuma Aplicação encontrada" />,
        content = switchable_element(h('section', { class: "full-size" }, ept_msg)),
        box_btns = [
            <Btn color="green" icon="assets/image/plus.svg" onClick={() => new_group()} />,
            <Btn icon="assets/image/x_white.svg" onClick={() => hide()} color="red" />
        ];

    const
        new_group = () => {
            GroupModal.show({
                created: async (data) => {
                    await get_all_groups(data.id);
                    hide();
                }
            });
        },
        delete_group = (group) => {
            GenericConfirmModal.show({
                title: "Apagar Aplicação",
                text: `Tem certeza que deseja apagar ${group.name} ?`,
                confirm: async () => {
                    try {
                        shared.full_spinner.show();

                        await group_service.delete(group.id);

                        popupAlerts.success("Grupo apagado com sucesso!");

                        get_all_groups(); //esta função vai esconder o spinner
                    } catch (e) {
                        shared.full_spinner.hide();
                    };
                }
            });
        },
        fill_list = () => {
            content.switch(
                <section class="full-size">
                    {shared.group_array?.length ? _.map(shared.group_array, e => <GroupCard data={e} deleteClick={delete_group} />) : ept_msg}
                </section>
            );
        },
        get_all_groups = async (id) => {
            await shared.header.get_all_groups(id);
            fill_list();
        };

    onInit(() => { fill_list() });

    return (
        <Box title="Aplicações (grupos)" containerClass="box-list-groups" buttons={box_btns}>
            {content.current()}
        </Box>
    );
};

const ListGroupsModal = new Modal(ListGroups);

export default ListGroupsModal;